export default __webpack_public_path__ + "src/images/btn_zoom_in-52da21.png";